/**
 * Zuordnung Feldname → Zell-Renderer. Der Altclient vergleicht in
 * `IwmBasePageView.GetColumns` über `FieldName.ToLower()`, die Suche ist deshalb
 * unabhängig von der Groß-/Kleinschreibung.
 */

import type { CellRenderer, CellTemplateMap } from './types';

export function findTemplate<T>(
  map: CellTemplateMap<T>,
  fieldName: string,
): CellRenderer<T> | undefined {
  const needle = fieldName.toLowerCase();
  const match = Object.keys(map).find((key) => key.toLowerCase() === needle);
  return match === undefined ? undefined : map[match];
}
